import { fetchRoleAuthorization, fetchPageAuthorization } from '../api/loginApi'
import CryptoJS from 'react-native-crypto-js';
import { decode } from '../helpers/decode_env';
class AuthorizationService {
  static instance = null;
  static userId = null;
  static userName = null;
  static userRoles = [];
  static encryptionKey = process.env.REACT_APP_CLIENT_SECRET ? decode(process.env.REACT_APP_CLIENT_SECRET): '';
 
  encrypt = (value) => CryptoJS.AES.encrypt(value, AuthorizationService.encryptionKey).toString();
  decrypt = (encryptedValue) => CryptoJS.AES.decrypt(encryptedValue, AuthorizationService.encryptionKey).toString(CryptoJS.enc.Utf8);
  
  

  static getInstance() {
   
    if (!AuthorizationService.instance) {
      AuthorizationService.instance = new AuthorizationService();
      const userDetails = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) : null;

      if (userDetails) {
        const userId = userDetails.id;

        if (userId) {
          AuthorizationService.userId = userId;
        }
      }
    }
    return AuthorizationService.instance;
  }

  Initialize = async () => {
    const userDetails = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) : null;

    const authorizationString = sessionStorage.getItem('authorizations') ? sessionStorage.getItem('authorizations') : '';
    let authorizations = null;

    if (authorizationString) {
      const decryptedAuthorizationString = this.decrypt(authorizationString);
      authorizations = JSON.parse(decryptedAuthorizationString);
    }

    if (authorizations === null || authorizations === undefined) {
      if (userDetails) {
        AuthorizationService.userName = userDetails.name;
        AuthorizationService.userRoles = userDetails.roleId;
      } else {
        AuthorizationService.userName = null;
        AuthorizationService.userRoles = null;
      }
      const data = await fetchRoleAuthorization();
      const pageData = await fetchPageAuthorization();
      const roleAuthorizations = data?.data?.data?.area;
      const routeAuthorizations = pageData?.data?.data?.area;
      sessionStorage.setItem('authorizations', this.encrypt(JSON.stringify(roleAuthorizations)));
      sessionStorage.setItem('accessData', JSON.stringify(roleAuthorizations))
      sessionStorage.setItem('routeAccessData', JSON.stringify(routeAuthorizations))
    }
    else {
      AuthorizationService.userName = userDetails ? userDetails.name : null;
    }
  }
}

export default AuthorizationService;